import { useTranslation } from "react-i18next"

import { LinkedAttachmentEntity } from "entities/attachments/ui/linked-attachments/types/LinkedAttachmentEntity"

import { DeleteAttachmentOverlayModel } from "../DeleteAttachmentOverlay"

export interface DeleteAttachmentOverlayViewModel {
  headline: string
  description: string
  confirmButtonText: string
  fileName: string
  fileStem: string
  fileExtension: string
  linkedEntities: LinkedAttachmentEntity[] | null | undefined
  onDelete: () => void
  onClose: () => void
}

export function useDeleteAttachmentOverlayViewModel({
  payload,
  linkedEntities,
  onDelete,
  onClose
}: DeleteAttachmentOverlayModel): DeleteAttachmentOverlayViewModel {
  const { t } = useTranslation()

  const { fileName } = payload.attachment
  const lastDotIndex = fileName.lastIndexOf(".")
  const fileStem = lastDotIndex > 0 ? fileName.slice(0, lastDotIndex) : fileName
  const fileExtension = lastDotIndex > 0 ? fileName.slice(lastDotIndex + 1) : ""

  return {
    headline: t("Attachments.DeleteOverlay.Title"),
    description: t("Attachments.DeleteOverlay.Description"),
    confirmButtonText: t("Attachments.DeleteOverlay.ConfirmButton"),
    fileName,
    fileStem,
    fileExtension,
    linkedEntities,
    onDelete,
    onClose
  }
}
